import * as noUiSlider from 'nouislider';

// import Swiper from 'swiper';

// Import Swiper and modules
import { Swiper, Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/dist/js/swiper.esm.js';

// Install modules
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

export default {
  init() {
      $( document ).ready(function() {
          //Close Burger menu when hitting society link
          $('#menu-item-953').on('click', function (f) {
              if ($(window).width() < 1350) {
                  $(f.target).closest('.main-menu').prev('.main-burger').click();
              }
          });

          // change color and underlined the right page in header
          let currentUrl = window.location.href;
          const protocole = 'http:';
          function addShownPageClass() {
              $('header a').each(function () {
                  if (protocole + $(this).attr('href') === currentUrl || $(this).attr('href') === currentUrl) {
                      $(this).addClass('shown-page');
                  }
              });
          }
          addShownPageClass();

          //count nb of other goods et give them a column and row in the grid for IE
          if(/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
              //Other programmes and references
              if ($('.other-prog')) {
                  let k = 1;
                  let l = 1;
                  $('.other-prog').each(function () {
                      $(this).addClass("grid-col" + k + " grid-row" + l);
                      if (k < 5) {
                          k = k + 2;
                      } else {
                          l++;
                          k = 1;
                      }
                  });
              }

              //disponibilities (lots)
              if ($('.dispo-list')) {
                  let k = 1;
                  let l = 1;
                  let colNb = 1;
                  if ($(window).width() < 1200) {
                      colNb = 1;
                  } else if ($(window).width() < 1800) {
                      colNb = 3;
                  } else {
                      colNb = 5;
                  }
                  $('.flat').each(function () {
                      $(this).addClass("grid-col" + k + " grid-row" + l);
                      if (k < colNb) {
                          k = k + 2;
                      } else {
                          l++;
                          k = 1;
                      }
                  });
              }

              //Pictures wall
              if ($('.pictures-wall')) {
                  let k = 1;
                  let l = 1;
                  let colNb = 1;
                  if ($(window).width() < 768) {
                      colNb = 1;
                  } else if ($(window).width() < 1200) {
                      colNb = 3;
                  } else {
                      colNb = 5;
                  }
                  $('.wall-pic').each(function () {
                      $(this).addClass("grid-col" + k + " grid-row" + l);
                      if (k < colNb) {
                          k = k + 2;
                      } else {
                          l++;
                          k = 1;
                      }
                  });
              }

              //Description assets
              if ($('.assets')) {
                  let k = 1;
                  let l = 1;
                  let colNb = 1;
                  if ($(window).width() < 576) {
                      colNb = 2;
                  } else {
                      colNb = 3;
                  }
                  $('.assets div').each(function () {
                      $(this).addClass("grid-col" + k + " grid-row" + l);
                      if (k < colNb) {
                          k++;
                      } else {
                          l++;
                          k = 1;
                      }
                  });
              }
          }

          // Swiper Slider for header images
          if ($('.swiper-container-header')) {
              new Swiper ('.swiper-container-header', {
                  direction: 'horizontal',
                  loop: true,
                  slidesPerView: '1',
                  initialSlide: 0,
                  simulateTouch: true,
                  pagination: {
                      el: '.swiper-pagination-header',
                      clickable: true,
                  },
                  autoplay: {
                      delay: 5000,
                  },
              });
          }

          // Swiper Slider for the state of the programme on mobile
          if ($('.swiper-container')) {
              const stateInit = $('.actual-state').data('state-init');

              new Swiper ('.swiper-container', {
                  direction: 'horizontal',
                  loop: false,
                  slidesPerView: '1',
                  initialSlide: (stateInit !== undefined) ? (stateInit - 1) : 0,
                  pagination: {
                      el: '.swiper-pagination',
                      clickable: true,
                  },
              });
          }
      });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

      // Go to the good page when clicking on the good box
      $('.box').click(function () {
        if($(this).data('go-to'))
          window.location.href = $(this).data('go-to');
      });

      // Show only goods of selected type on by-a-good page
      if ($('.goods-choice')) {
          $('input[type="radio"]').change(function () {
              var radioValue = $('input[name="type"]:checked').val();
              var count = 0;
              $('.goods-sale .box').each(function () {
                  if (radioValue !== 'Tous') {
                      if (!$(this).hasClass(radioValue)) {
                          $(this).addClass('hidden-good');
                      } else {
                          $(this).removeClass('hidden-good');
                          count++;
                      }
                  } else {
                      $(this).removeClass('hidden-good');
                      count++;
                  }
              });
              if (count === 0) {
                  $('.goods-sale .no-disponibility').removeClass('hidden-good');
              } else {
                  $('.goods-sale .no-disponibility').addClass('hidden-good');
              }
              $(document).scrollTop( $('#goods-selection').offset().top );
          });
      }


  // Events on Upload boxes
      // Add an upload box on "vendre un bien" page when clicking on +
      let uploadNb = 3;
      $('#add-upload').click(function () {
          uploadNb++;
          $(this).before('<div><input type="file" name="doc' + uploadNb + '" id="doc' + uploadNb + '" accept="image/jpg,image/jpeg,image/gif,image/png,application/pdf"><label for="doc' + uploadNb + '" class="doc-label"></label><span class="delete-upload"></span></div>');
          if(uploadNb >= 10) {
              $(this).addClass('enough-img');
          }
      });

      // Add a background when an image is upload in sell form (the live function binds elements which are added to the DOM at later time)
      $(document).on('change', 'input[type=file]', function() {
          console.log($(this));
          var targetInput = '#' + $(this)[0].id;
          if ($(this)[0].files && $(this)[0].files[0]) {
              var reader = new FileReader();
              reader.onload = function (e) {
                  $(targetInput).next($('.doc-label')).css('background-image', 'url("' + e.target.result + '")');
                  $(targetInput).parent().addClass('loaded-pic');
              };
              reader.readAsDataURL($(this)[0].files[0]);
          } else {
              $(targetInput).next($('.doc-label')).css('background-image', 'unset');
              $(targetInput).parent().removeClass('loaded-pic');
          }
      });

      // Remove upload thumbnail and clear input file when clicking on the cross
      $(document).on('click', '.delete-upload', function () {
          $(this).prev().css('background-image', 'unset');
          var prevSiblings = $(this).prevAll();
          prevSiblings[1].value = '';
          $(this).parent().removeClass('loaded-pic');
          console.log(prevSiblings);
      });


    //noUIslider
      // Double range area
      if (document.getElementById('slider-snap-area')) {
          var priceRange = document.getElementById('slider-snap-area');
          noUiSlider.create(priceRange, {
              start: [50, 750],
              range: {
                  'min': [20],
                  'max': [1000],
              },
              step: 5,
              // snap: true,
              connect: true,
              behaviour: 'tap-drag',
              // tooltips: true,
          });
          var snapValuesPrice = [
              document.getElementById('slider-snap-area-value-lower'),
              document.getElementById('slider-snap-area-value-upper'),
          ];
          priceRange.noUiSlider.on('update', function (values, handle) {
              snapValuesPrice[handle].innerHTML = Math.floor(values[handle]);
          });
      }

      //Double range budget
      if (document.getElementById('slider-snap-budget')) {
          var budgetRange = document.getElementById('slider-snap-budget');
          noUiSlider.create(budgetRange, {
              start: [150000, 1000000],
              range: {
                  'min': [10000],
                  'max': [2000000],
              },
              step: 10000,
              connect: true,
              behaviour: 'tap-drag',
          });
          var snapValuesBudget = [
              document.getElementById('slider-snap-budget-value-lower'),
              document.getElementById('slider-snap-budget-value-upper'),
          ];
          budgetRange.noUiSlider.on('update', function (values, handle) {
              snapValuesBudget[handle].innerHTML = Math.floor(values[handle]);
          });
      }

      // Get values of both noUIslider when they change and put them in hidden inputs of the form
      $(document).on('DOMSubtreeModified', '.nb-form-value', function () {
         let newValue = $(this).text();
         $(this).next('input').val(newValue);
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js